var runtime = require("../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"spinner-container":"_3_bhL","spinnerContainer":"_3_bhL","spinner":"-A2_X"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3_bhL{background-color:"+process("color(--wix-colors-backgroundColor)")+"}"+wrap+" .-A2_X{color:"+process("color(--wix-colors-buttonsAndLinksColor)")+"}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

